module.exports = __webpack_public_path__ + "img/mouse-square.2a2edb31.svg";